/**
 * Cargando
 * @returns {string}
 */
function cargando() {
    return '<div id="loading">' +
        '<img src="img/load.gif">' +
        '</div>';
}

/**
 * Solo numeros
 * @param evt
 * @returns {boolean}
 */
function isNumberKey(evt) {
    var charCode = (evt.which) ? evt.which : event.keyCode;
    return !(charCode > 31 && (charCode < 48 || charCode > 57));
}

/**
 * Funcion para insercion en la base de datos
 * mediante ajax
 *
 * @param archivo
 * @param tipoInsert
 * @param form
 * @param tablaRecargar
 * @param dondeRecargar
 * @param notificar
 * @param blockPage // Bloquear la pagina temporalmente
 */
function AjaxIn(archivo, tipoInsert, form, tablaRecargar, dondeRecargar, notificar, blockPage) {
    var datosEnviados;

    //poner la notificacion por default
    if (typeof(notificar) === 'undefined') {
        notificar = true;
    }
    if (blockPage == void 0) {
        blockPage = true;
    }

    //si esta nulo paso el primer form
    if (form === '' || !form) {
        //tomar los datos
        datosEnviados = $('form').first().serializeArray();
        //console.log(('Formulario: ' + f.first().attr('id')).trim());
    } else {
        //los dato del form
        datosEnviados = $('#' + form).serializeArray();
    }
    console.log('Form: ' + form);

    //pongo el resul abajo del form
    $('body').after('<div id="resul_envio"></div>');
    console.log(datosEnviados);

    //si la pagina se tiene que bloquear
    if (blockPage) {
        $('body').after('<div id="block"></div>');
        var block = $('#block');

        //aplicar css a la pagina
        block.css({
            'position': 'fixed',
            'height': '100%',
            'width': '100%',
            'display': 'block',
            'background-color': 'rgba(0,0,0,0.5)',
            'top': '0',
            'left': '0',
            'z-index': '300'
        });
    }

    //lo guardo en un variable
    var resultado = $('#resul_envio');

    /**
     * aplicar css al resultado
     */
    if (notificar == true) {
        //estilo
        resultado.css({
            'display': 'none',
            'font-size': '16px',
            'padding': '20px',
            'border': '1px solid grey',
            'color': '#501919',
            'background-color': 'rgba(256,256,256,1)',
            'border-radius': '0',
            'text-transform': 'uppercase',
            'margin': '0 auto',
            'position': 'fixed',
            'top': '30%',
            'left': '50%',
            'min-width': '20%',
            'z-index': '1999',
            'box-shadow': '1px 1px 1px grey',
            'transform': 'translate(-50%,-50%)',
            '-webkit-transform': 'translate(-50%,-50%)',
            '-moz-transform': 'translate(-50%,-50%)',
            '-ms-transform': 'translate(-50%,-50%)',
            '-o-transform': 'translate(-50%,-50%)',
            'text-align': 'center'
        });
    } else {
        resultado.css('display', 'none');
    }
    /**
     * El archivo que se encarga de realizar las acciones en el server
     * @type {string}
     */
    var archivoF = archivo + '.php?tipo=' + tipoInsert;

    /**
     * Envio la consulta al server
     */
    $.ajax({
        beforeSend: function () {
            Load.loadingAjax();
        },
        url: archivoF,
        type: 'POST',
        data: datosEnviados,
        success: function (response) {
            resultado.css({
                'display': 'block'
            });
            //cerrar cargando
            Load.close();
            console.log((response).trim());
            //mostrar en pantalla
            resultado.html((response).trim());
            //guardar ultimo response
            window.sessionStorage.lastData = response;

            //sacar el aviso
            setTimeout(function () {
                resultado.remove();
                if (blockPage) {
                    block.remove();
                }
            }, 1500);

            //si se necesita recargar los datos en la pantalla
            if (tablaRecargar != '' || dondeRecargar != '') {
                LoadPHP(tablaRecargar, dondeRecargar);
            }
        },
        error: function (response) {
            Load.close();
            resultado.text('Error de conexion. Vuelva a intentar' + response.responseText);
        }
    })
}

/**
 * Tomar URL completa
 * @returns {{}}
 */
function getVarsUrl() {
    var url = location.search.replace("?", "");
    var arrUrl = url.split("&");
    var urlObj = {};
    for (var i = 0; i < arrUrl.length; i++) {
        var x = arrUrl[i].split("=");
        urlObj[x[0]] = x[1]
    }
    return urlObj;
}

/**
 * funcion para carga de php
 * @param archivo
 * @param donde
 */
function LoadPHP(archivo, donde) {
    $(donde).before('<div id="resultado"></div>');

    $.ajax({
        type: "GET",
        url: archivo,
        data: '',
        dataType: "html",
        beforeSend: function () {
            //imagen de carga
            //$("#resultado").html(cargando());
            Load.loadingAjax();
        },
        error: function (data) {
            Load.close();
            console.log("error peticion ajax" + data);
        },
        success: function (data) {
            Load.close();
            $(donde).html(data);
            $("#resultado").remove();
            ajustesVisuales();

        }
    });
}


/**
 * Borrar un cliente de la base
 * @param mailC
 * @returns {boolean}
 */
function deleteCliente(mailC) {
    if (!confirm('Se desactivara al cliente, ' +
            'NO se eliminara. Los reclamos seguiran activos. ' +
            'Pero no podra ingresar nuevos. ' +
            '¿Desea continuar?')) {
        return false;
    } else {
        AjaxIn('fun/actions', 'deleteCliente&mailC=' + mailC, 'in', 'sec/listarClientes.php', '.data')
    }
}

/**
 * Subir imagen mediante ajax
 * @param form
 * @param urlArchivoSubida
 * @param imagen
 */
function subirAjax(form, urlArchivoSubida, imagen) {
    if (imagen == void 0) {
        imagen = true;
    }

    var dataUp = $('#data-up');

    if (dataUp.length == 0) {
        $('#' + form).after('<div id="data-up"></div>')
    } else {
        dataUp.remove();
        $('#' + form).after('<div id="data-up"></div>')
    }

    var a = new FormData($("#" + form)[0]);
    if (!a) {
        return false;
    }
    $.ajax({
        url: urlArchivoSubida,
        type: "POST",
        data: a,
        cache: !1,
        contentType: !1,
        processData: !1,
        beforeSend: function () {
            $("#" + form).after('' +
                '<div id="load" align="center">' +
                '<img src="http://loadinggif.com/generated-image?imageId=1&bgColor=%23ffffff&fgColor=%23000008&transparentBg=1&download=0&random=0.041722657857462764" alt="">' +
                '</div>');
        },
        success: function (data) {
            console.log(data);
            $('#load').remove(); //borrar el cargando

            if (imagen) {
                setTimeout(function () {
                    $("#" + form).after('' +
                        '<div id="data-up" style="text-align: center">' +
                        '<img style="width:50%;margin:5px" src="' + $.trim(data) + '" alt="subida">' +
                        '</div>');
                }, 200);
            }
        },
        error: function () {
            alert('Error ajax');
        }
    });

    return true;
}



/**
 * Ajuste visuales del sistema
 */
function ajustesVisuales() {

    webshims.setOptions('forms-ext', {types: 'date'});
    webshims.polyfill('forms forms-ext');

    // $.material.init();
    var button = $('button');
    var select = $('select');
    var input = $(':text,textarea,input [type=number],input [type=password]');
    var table = $('table');

    input.addClass('form-control');

    select.attr('data-live-search', 'true');
    select.selectpicker();
    select.addClass('form-control');
    select.addClass('selectpicker');
    //select.addClass('show-tick');

    table.addClass('table');
    //table.addClass('table-condensed');
    //table.addClass('rwd-table');
    //table.addClass('table-hover');

    //agrandar modal
    $('.modal').addClass('modal-wide');
    $(".modal-wide").on("show.bs.modal", function () {
        var height = $(window).height() - 200;
        $(this).find(".modal-body").css("max-height", height);
    });

    //navegacion lateral
    MENU.alto();
}


/**
 * Asociar Cliente
 * @param producto
 * @param cliente
 * @param id
 */
function asociarCliente(producto, cliente, id) {
    $.ajax({
        url: './fun/actions.php',
        method: 'POST',
        data: {
            tipo: 'asociarProductoCliente',
            cliente: cliente,
            producto: producto
        },
        success: function (res) {
            console.log(res);
            var data = $.trim(res);
            var iden = $('#' + id);

            if (data == 'si') {
                iden.removeClass('bg-default');
                iden.addClass('bg-success');
            } else {
                iden.removeClass('bg-success');
                iden.addClass('bg-default');
            }
        },
        error: function (res) {
            console.log('Error' + res);
        }
    })
}